module.exports = __webpack_public_path__ + "static/media/27.719b53cd.jpeg";